import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', [_c('tip')], 1), _c('my-enter-search', {
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "data-permission": "product_original_label_search_sku",
      "id": "product_original_label_search_sku",
      "value": "product_sku"
    }
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "product_original_label_search_reference",
      "id": "product_original_label_search_reference",
      "value": "reference_number"
    }
  }, [_vm._v(_vm._s(_vm.t('参考编码')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "product_original_label_search_name_cn",
      "id": "product_original_label_search_name_cn",
      "value": "product_name_cn"
    }
  }, [_vm._v(_vm._s(_vm.t('中文名称')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "product_original_label_search_barcode",
      "id": "product_original_label_search_barcode",
      "value": "relation_barcode"
    }
  }, [_vm._v(_vm._s(_vm.t('原标商品编码')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u8F93\u5165"),
      "placeholder": _vm.t('输入')
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('来源仓')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u8F93\u5165"),
      "data-permission": "product_original_label_search_source_storehouse",
      "id": "product_original_label_search_source_storehouse",
      "placeholder": _vm.t('输入')
    },
    model: {
      value: _vm.searchData.third_part_platform,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "third_part_platform", $$v);
      },
      expression: "searchData.third_part_platform"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('更新时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "product_original_label_search_update",
      "id": "product_original_label_search_update",
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.searchDateTime,
      callback: function ($$v) {
        _vm.searchDateTime = $$v;
      },
      expression: "searchDateTime"
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "loading": _vm.loadingStatus,
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mt-20"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedIdList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_original_export',
      expression: "'product_original_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "product_original_export_all",
      "id": "product_original_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "product_original_export_select",
      "id": "product_original_export_select",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_original_delete_bulk',
      expression: "'product_original_delete_bulk'"
    }],
    staticClass: "margin-left",
    attrs: {
      "data-permission": "product_original_delete_bulk",
      "id": "product_original_delete_bulk",
      "disabled": !_vm.$config.showProductOriginalLabelAddBtn,
      "fbu-analyse-name": $t("\u5220\u9664")
    },
    on: {
      "click": _vm.handleRemoveSelectedSkuMapping
    }
  }, [_vm._v(" " + _vm._s(_vm.t('删除')))]), _vm.$config.showProductOriginalLabelAddBtn ? [_c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_original_add',
      expression: "'product_original_add'"
    }],
    staticClass: "ml-15 fr",
    attrs: {
      "data-permission": "product_original_add",
      "id": "product_original_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAddMapping
    }
  }, [_vm._v(" " + _vm._s(_vm.t('新增')))]), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_original_add_bulk',
      expression: "'product_original_add_bulk'"
    }],
    staticClass: "ml-15 fr",
    attrs: {
      "data-permission": "product_original_add_bulk",
      "id": "product_original_add_bulk",
      "type": "primary",
      "ghost": "",
      "fbu-analyse-name": $t("\u6279\u91CF\u65B0\u589E")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'ImportOriginalLabelPage'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t('批量新增')))])] : _vm._e()], 2), _c('a-skeleton', {
    attrs: {
      "loading": _vm.listLoading,
      "active": ""
    }
  }, [_c('my-table', {
    staticClass: "mt-20",
    attrs: {
      "fixed-header": "",
      "useMouseTool": "",
      "is-filter-box": "",
      "name": "originalLabelProductList",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "row-selection": _vm.rowSelection,
      "bordered": "",
      "row-key": "product_id"
    },
    scopedSlots: _vm._u([{
      key: "productSkuVsNumber",
      fn: function (ref) {
        var row = ref.row;
        return _c('span', {}, [_vm._v(" " + _vm._s(row.pcr_product_sku) + "*" + _vm._s(row.pcr_quantity) + " ")]);
      }
    }, {
      key: "product_name_cn",
      fn: function (ref) {
        var row = ref.row;
        return _c('div', {}, [_c('text-ellipses', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: row.product_name_cn,
            expression: "row.product_name_cn"
          }],
          attrs: {
            "data": row.product_name_cn,
            "width": 220
          }
        })], 1);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var row = ref.row;
        return _c('my-operation', {}, [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'product_original_edit',
            expression: "'product_original_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "href": "javascript:",
            "disabled": !_vm.$config.showProductOriginalLabelAddBtn,
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEditMapping(row);
            }
          }
        }, [_vm._v(_vm._s(_vm.tc('编辑')))]), _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'product_original_delete',
            expression: "'product_original_delete'"
          }],
          attrs: {
            "href": "javascript:",
            "disabled": !_vm.$config.showProductOriginalLabelAddBtn,
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleRemoveSkuMapping(row);
            }
          }
        }, [_vm._v(_vm._s(_vm.tc('删除')))])]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "total": _vm.total,
      "orderListEsPoint": _vm.searchData.zt_list_es_point,
      "isFixed": "",
      "name": "originalLabelProductList",
      "value": _vm.searchData.page_index,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "onChange": _vm.handlePageChange,
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      }
    }
  }), _c('add-edit-sku-mapping', {
    ref: "addEditSkuMappingRef",
    attrs: {
      "mode": _vm.operatingStatus,
      "data": _vm.editData
    },
    on: {
      "success": _vm.handleSuccess
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };